export type PublishOption = {
  id: string;
  label: string;
  value: string;
};

// Default fallback value when resetting publish version state
export const DEFAULT_PUBLISH_VERSION: PublishOption = {
  id: "draft",
  label: "Draft",
  value: "Draft",
};

export type ClientOption = {
  id: string;
  label: string;
  value: string;
  title?: string; // For showing full name on hover
};

export type AccountOption = {
  id: string;
  label: string;
  value: string;
  title?: string; // For showing full name on hover
};
